import React, { ReactNode } from 'react';
import { Col, Row } from 'reactstrap';

import maximize from 'assets/maximize.svg';
import minimize from 'assets/minimize.svg';

/**
 * A section of the offer page under the positions (e.g. the delivery terms) that is opened
 * and closed from its title with the plus and minus icons, like the products section.
 */
const CollapsibleOfferSection = ({
  children,
  isOpen,
  title,
  toggle,
}: {
  children: ReactNode;
  isOpen: boolean;
  title: string;
  toggle: () => void;
}): JSX.Element => (
  <>
    <Row>
      <Col>
        <div
          className="header-text title-spacing"
          onClick={toggle}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              toggle();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <img
            src={isOpen ? minimize : maximize}
            alt={title}
            className="collapse-icon"
          />
          {title.toUpperCase()}
        </div>
      </Col>
    </Row>
    {isOpen ? children : null}
  </>
);

export default CollapsibleOfferSection;
